import { RootState } from '@/store/main';

export const getSolutions = (state: RootState) => state.integrations.solutions;
export const getAvailableInstances = (state: RootState) => state.integrations.availableInstances;
export const getIsLoadingIntegrations = (state: RootState) => state.integrations.loadingIntegrations;
export const getRSVPLinkSync = (state: RootState) => state.integrations.rsvpLinkSync;
